import React from 'react';
import { Controller } from 'react-hook-form';
import { InputTextarea } from 'primereact/inputtextarea';
import { Tooltip } from 'primereact/tooltip';
import classNames from 'classnames';
import SpamSuggestions from './spam-suggestions';
import Picker from '@emoji-mart/react';
import data from '@emoji-mart/data';
import { ReactComponent as Emoji } from '../../../../assets/svgIcons/emoji.svg';
import { Menu } from 'primereact/menu';
import { InputText } from 'primereact/inputtext';
import { CustomButton } from '../../../../components/CustomButton';

const TEMPLATE_DOC_URL =
  'https://skalebot-product-catalog.s3.ap-south-1.amazonaws.com/skalebot-docs/guidelines.pdf'; // replace with your actual URL

const TemplateBodyField = ({
  control,
  textAreaRef,
  getFormErrorMessage = () => {},
  SPAM_SUGGESTIONS,
  showSpamSuggestions,
  setShowSpamSuggestions,
  checkForSpam,
  messsageVariables,
  menuRef,

  showEmoji,
  setShowEmoji,
  handleEmojiClick,

  tempVariables,
  handleEditVariable,
  handleDeleteVariable,
  watchContent,
  bodyLabel = 'Body *',
}) => {
  return (
    <>
      <div className="w-full relative">
        <label htmlFor="content" className="inline-block mb-2">
          {bodyLabel}
        </label>
        <Controller
          name="content"
          control={control}
          spellCheck={true}
          rules={{ required: 'Content is required.' }}
          render={({ field, fieldState }) => {
            const spamMatches = checkForSpam(field.value || '');

            return (
              <div className="relative">
                <InputTextarea
                  className={classNames(
                    {
                      'p-invalid': fieldState.invalid || spamMatches.length > 0,
                    },
                    'w-full',
                  )}
                  id={field.name}
                  value={field.value}
                  rows={3}
                  cols={30}
                  {...field}
                  maxLength={1028}
                  placeholder="Enter your content (max 1028 chars)"
                  ref={textAreaRef}
                />

                {spamMatches.length > 0 && (
                  <SpamSuggestions
                    spamMatches={spamMatches}
                    showSuggestions={showSpamSuggestions}
                    setShowSuggestions={setShowSpamSuggestions}
                    fieldValue={field.value}
                    SPAM_SUGGESTIONS={SPAM_SUGGESTIONS}
                    onReplace={(word) => {
                      const updated = field.value.replace(
                        new RegExp(word, 'gi'),
                        SPAM_SUGGESTIONS[word] || '',
                      );
                      field.onChange(updated);
                    }}
                  />
                )}
                {getFormErrorMessage('content')}
                <div className="mt-2 flex flex-row align-items-center gap-2 bg-gray-100 p-2 border-round-sm">
                  <i
                    className="pi pi-info-circle cursor-pointer open-doc-icon"
                    data-pr-tooltip="Click to view template documentation"
                    data-pr-position="top"
                    onClick={() => window.open(TEMPLATE_DOC_URL, '_blank')}
                    style={{ fontSize: '1.2rem' }}
                    color="text-gray-600"
                  />
                  <small className="flex flex-wrap">
                    The text limit in the body should be less than 550 characters and emojis should
                    be less than 10 to avoid any template rejection
                  </small>
                </div>
              </div>
            );
          }}
        />

        <Tooltip target=".open-doc-icon" />
      </div>
      {/* Variables + Emoji Toolbar */}

      <div className="w-full flex justify-content-between relative mt-2">
        <div>
          <Menu model={messsageVariables} popup ref={menuRef} />

          <CustomButton
            varient="outline"
            type="button"
            icon="pi pi-plus"
            label="Add Variables"
            onClick={(event) => menuRef.current.toggle(event)}
          />
        </div>

        <span
          className="cursor-pointer"
          onClick={(event) => {
            event.stopPropagation();
            setShowEmoji((prev) => !prev);
          }}
        >
          <Emoji width={28} fill="grey" />
        </span>

        {showEmoji && (
          <div
            className="absolute w-full flex justify-content-end"
            style={{ right: 0, top: 40, zIndex: 3 }}
          >
            <Picker
              data={data}
              onEmojiSelect={handleEmojiClick}
              onClickOutside={() => setShowEmoji(false)}
            />
          </div>
        )}
      </div>

      {tempVariables?.length !== 0 && (
        <div className="w-full mt-2">
          {tempVariables?.map((item, i) => (
            <div key={item.id} className="my-2 flex gap-2 align-items-center">
              <div className="min-w-min">
                {i === 0 && <label className="mb-2 block">Variable</label>}
                <InputText value={item.variableName} disabled />
              </div>

              <div className="flex-grow-1">
                {i === 0 && <label className="mb-2 block">Sample Value</label>}

                <div className="flex align-items-center gap-2">
                  <InputTextarea
                    rows={1}
                    autoResize
                    value={item.variableValue}
                    placeholder="Enter sample value"
                    onChange={(e) => handleEditVariable(e, item.id)}
                    className="w-full"
                  />

                  <i
                    className="pi pi-trash cursor-pointer"
                    onClick={() => handleDeleteVariable(item.id, tempVariables, watchContent)}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default TemplateBodyField;
